import { PROPS_TYPE } from 'app/automations/automation-helpers-actions';
import { CustomModelProperty } from 'app/automations/automations-models';
import { FieldMappingPair } from './field-mapping-pair';

/** What the destination dropdown's blank option stores. */
const UNMAPPED_VALUE = 'none';

export function isFieldMappingPropName(name: string | undefined): boolean {
  return name === PROPS_TYPE.FieldValue || name === PROPS_TYPE.FieldName;
}

function isFilled(prop: CustomModelProperty): boolean {
  return !!prop.value && prop.value !== UNMAPPED_VALUE;
}

/**
 * Matched by adjacency, not index arithmetic: `properties` opens with a list/tag property only when the
 * action carries a list, so any fixed offset is wrong for one of the two shapes.
 */
function adjacentFieldMappingPairs(properties: CustomModelProperty[] | undefined): FieldMappingPair[] {
  const props = properties ?? [];
  const pairs: FieldMappingPair[] = [];
  let index = 0;
  while (index < props.length - 1) {
    const first = props[index];
    const second = props[index + 1];
    if (!isFieldMappingPropName(first?.name) || !isFieldMappingPropName(second?.name) || first.name === second.name) {
      index++;
      continue;
    }
    pairs.push({ first, second });
    index += 2;
  }
  return pairs;
}

export function fieldMappingPairs(properties: CustomModelProperty[] | undefined): FieldMappingPair[] {
  return adjacentFieldMappingPairs(properties).filter((pair) => isFilled(pair.first) && isFilled(pair.second));
}

/** `fieldMappingPairs` drops a half-filled row, so serializing one silently discards the user's pick. */
export function hasHalfFilledFieldMappingPair(properties: CustomModelProperty[] | undefined): boolean {
  return adjacentFieldMappingPairs(properties).some((pair) => isFilled(pair.first) !== isFilled(pair.second));
}
